<template>
  <sub-frame title="标的物信息">
    <div slot="head">
      <mt-button
        icon="more"
        v-if="actions.length"
        type="primary"
        @click="sheetVisible = !sheetVisible"
      ></mt-button>
    </div>
    <mt-actionsheet :actions="actions" v-model="sheetVisible" />
    <mt-cell title="标的物类型" :value="subject.kind"></mt-cell>
    <mt-cell title="标的物名称" :value="subject.name"></mt-cell>
    <!-- <mt-cell title="标的物编号" :value="subject.number"></mt-cell> -->
    <mt-field
      label="标的物编号"
      v-model="subject.number"
      :disabled="disabled"
    ></mt-field>
    <swipe-image :attachments="subject.attachments"></swipe-image>
  </sub-frame>
</template>

<script>
export default {
  name: "ApplySubject",
  data() {
    return {
      applyGuid: this.$route.query.applyGuid,
      disabled: true,
      subject: {
        guid: "",
        name: "",
        number: "",
        kind: "",
        attachments: "",
      },
      sheetVisible: false,
      actionsAll: [
        {
          name: "编辑修改",
          method: () => (this.disabled = false),
        },
        {
          name: "保存修改",
          method: this.saveApplySubjectInfo,
        },
      ],
    };
  },
  created() {
    this.getApplySubjectInfo();
  },
  computed: {
    actions() {
      if (this.$store.state.notaryRights.applicant_modify) {
        return [this.actionsAll[this.disabled ? 0 : 1]];
      } else {
        return [];
      }
    },
  },
  methods: {
    async getApplySubjectInfo() {
      let res = await this.$axios.get(`/applycheck/applysubject`, {
        params: {
          applyGuid: this.applyGuid,
        },
      });
      // console.log(res.data);
      this.subject = res.data;
      this.applyGuid = res.data.guid;
    },
    async saveApplySubjectInfo() {
      let res = await this.$axios.post(
        `/applycheck/ApplyBrandModify`,
        {
          guid: this.applyGuid,
          brand_Number: this.subject.number,
        }
      );
      // console.log(res.data);
      if(res.data.code==200){
        this.$toast("修改成功");
      }else{
        this.$toast("修改失败，请重试");
      }
    },
  },
};
</script>

<style scoped></style>
